import type {
  ScheduleSchedule,
  ScheduleScheduleCreate,
  ScheduleScheduledEvent,
  ScheduleScheduleUpdate,
  ScheduleSearchSchedulesV1Params,
} from '@shipium-corp/shipium-ts-types';
import GatewayAxiosClient from '~/store/services/GatewayAxiosClient';
import type { CreateManualManifestData } from '~/store/services/ScheduleService/types';

export interface ManifestScheduleStatusResponse {
  nextUpcomingEvent?: ScheduleScheduledEvent;
  mostRecentPastEvent?: ScheduleScheduledEvent;
}

export const schedules = {
  search: {
    queryKey: 'schedule-service/schedules',
    configurationType: 'cached' as const,
    fn: async (params: ScheduleSearchSchedulesV1Params = {}) => {
      const { data } = await GatewayAxiosClient.get<ScheduleSchedule[]>(`/scheduler-proxy/api/v1/schedules`, {
        params,
      });
      return data;
    },
  },
  getStatus: {
    queryKey: 'schedule-service/schedules/id/status',
    configurationType: 'cached' as const,
    fn: async (scheduleId: string) => {
      const { data } = await GatewayAxiosClient.get<ManifestScheduleStatusResponse>(
        `/manifests/schedules/${scheduleId}/status`,
      );

      return data;
    },
  },
  create: async (schedule: ScheduleScheduleCreate) => {
    const { data } = await GatewayAxiosClient.post<ScheduleSchedule>(`/scheduler-proxy/api/v1/schedules`, schedule);

    return {
      data,
      invalidateQueryKeys: [['schedule-service/schedules']],
    };
  },
  createManual: async (manifest: CreateManualManifestData) => {
    const { data } = await GatewayAxiosClient.post<ScheduleScheduledEvent>(`/manifests/manual`, manifest);

    return {
      data,
      invalidateQueryKeys: [['schedule-service/schedules']],
    };
  },
  update: async ({
    scheduleId,
    schedule,
  }: {
    scheduleId: string;
    schedule: ScheduleScheduleUpdate | { active: boolean };
  }) => {
    const { data } = await GatewayAxiosClient.put<ScheduleSchedule>(
      `/scheduler-proxy/api/v1/schedules/${scheduleId}`,
      schedule,
    );

    return {
      data,
      invalidateQueryKeys: [
        ['schedule-service/schedules'],
        ['schedule-service/schedules/id', scheduleId],
        ['schedule-service/schedules/id/status', scheduleId],
      ],
    };
  },
};
